import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

const freqError = 'Select a frequency';
const amountError = 'Enter an amount';

export const validateIncome = income => {
  let errors = {};

  if (income) {
    if (
      income[Fields.Income1] &&
      income[Fields.Income1] > 0 &&
      (income[Fields.Freq1] === undefined || income[Fields.Freq1] === -1)
    ) {
      errors[Fields.Freq1] = freqError;
    }

    if (
      income[Fields.Income2] &&
      income[Fields.Income2] > 0 &&
      (income[Fields.Freq2] === undefined || income[Fields.Freq2] === -1)
    ) {
      errors[Fields.Freq2] = freqError;
    }

    if (
      income[Fields.Income3] &&
      income[Fields.Income3] > 0 &&
      (income[Fields.Freq3] === undefined || income[Fields.Freq3] === -1)
    ) {
      errors[Fields.Freq3] = freqError;
    }

    if (
      income[Fields.Income4] &&
      income[Fields.Income4] > 0 &&
      (income[Fields.Freq4] === undefined || income[Fields.Freq4] === -1)
    ) {
      errors[Fields.Freq4] = freqError;
    }

    if (
      income[Fields.Freq1] !== undefined &&
      income[Fields.Freq1] > -1 &&
      (!income[Fields.Income1] || income[Fields.Income1] <= 0)
    ) {
      errors[Fields.Income1] = amountError;
    }

    if (
      income[Fields.Freq2] !== undefined &&
      income[Fields.Freq2] > -1 &&
      (!income[Fields.Income2] || income[Fields.Income2] <= 0)
    ) {
      errors[Fields.Income2] = amountError;
    }

    if (
      income[Fields.Freq3] !== undefined &&
      income[Fields.Freq3] > -1 &&
      (!income[Fields.Income3] || income[Fields.Income3] <= 0)
    ) {
      errors[Fields.Income3] = amountError;
    }

    if (
      income[Fields.Freq4] !== undefined &&
      income[Fields.Freq4] > -1 &&
      (!income[Fields.Income4] || income[Fields.Income4] <= 0)
    ) {
      errors[Fields.Income4] = amountError;
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/helpers/validation/IncomeValidator.js